import { Ads } from "@sphtech/dmg-design-system";

import Products from "./Products";
import ShopTheEdit from "./ShopTheEdit";

export const elementsWithoutDataSource = {
  adUnit: Ads.AdsMidContent,
};

export const elementsWithDataSource = {
  shopTheEdit: ShopTheEdit,
  products: Products,
};
